<template>
  <el-button
    :disabled="disabled || isLoading"
    @click="handleClickButton"
  >
    <i
      v-show="isLoading"
      class="el-icon-loading"
    />
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'ElLoadingButton',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClickButton() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
</style>
